var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ih-page-not-found ih-page"},[_c('h2',{staticClass:"text-center"},[_vm._v("404")])])}]

export { render, staticRenderFns }